import React, { useState } from "react";
import { PlayButton } from "../../grammar/shared";
import { ArabicLine, Prompt, CORRECT, WRONG, IDLE } from "./shared";

/** TrueFalseItem — a statement about the dialogue; reveals the deciding line. */
export default function TrueFalseItem({ question, onAnswer, audio }) {
  const { data } = question;
  const [picked, setPicked] = useState(null);

  const pick = (val) => {
    if (picked !== null) return;
    setPicked(val);
    onAnswer({ correct: val === data.is_true, answer: val });
  };

  const styleFor = (val) => {
    if (picked === null) return IDLE;
    if (val === data.is_true) return CORRECT;
    if (val === picked) return WRONG;
    return { ...IDLE, opacity: 0.6 };
  };

  return (
    <>
      <Prompt>{question.prompt_en}</Prompt>
      <p className="text-xl sm:text-2xl text-center font-medium max-w-xl mx-auto mb-6 leading-relaxed" style={{ color: "var(--parchment)" }}>
        {data.statement_en}
      </p>
      <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
        {[true, false].map((val) => (
          <button key={String(val)} type="button" disabled={picked !== null} onClick={() => pick(val)}
                  className="rounded-xl px-4 py-5 text-lg font-semibold transition-all hover:brightness-110 disabled:cursor-default"
                  style={styleFor(val)}>
            {val ? "✓ True" : "✗ False"}
          </button>
        ))}
      </div>
      {picked !== null && data.evidence_ar && (
        <div className="mt-5 flex items-center justify-center gap-3">
          <ArabicLine text={data.evidence_ar} size="text-2xl" color="var(--parchment-dim)" />
          {audio.audioAllowed && <PlayButton text={data.evidence_ar} playingText={audio.playingText} onPlay={audio.play} />}
        </div>
      )}
    </>
  );
}
